import { graphql, useStaticQuery } from "gatsby"

export const useBadges = () => {
  const { badges } = useStaticQuery(
    graphql`
      query UseBadges {
        badges: directusFiles(
          directus_id: { eq: "bc797f91-f44f-4baa-ab84-6a3d2769e735" }
        ) {
          cdn
        }
      }
    `
  )

  return badges
}
